module.exports = __webpack_public_path__ + "img/qihang_xiangqing.5ee887e4.png";